export default __webpack_public_path__ + "static/media/110.751be696.jpg";